import { CreateAnalyticEvent } from "@/actions/details/CreateAnalyticEvent";
import Box from "node_modules/@mui/material/esm/Box/Box";
import { useRef } from "react";

export function TrackedBox({ children }: { children: React.ReactNode }) {
  const ref = useRef<HTMLSpanElement>(null);
  const handleClick = () => {
    CreateAnalyticEvent({
      event: {
        adIds: ["NONE"],
        eventType: "CLICK#BOX",
        metadata: {
          text: ref.current?.textContent || "NONE",
        },
      },
    });
  };

  return (
    <Box ref={ref} onClick={handleClick}>
      {children}
    </Box>
  );
}
